import React from 'react'
import '../styles/pages/MissedSession.scss'
function MissedSession() {
    return (
        <div className='MissedSession'>
            <h1>you have no missed sessions</h1>
        </div>
    )
}

export default MissedSession
